/**
 * BookmarkBulkIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BookmarkBulkIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M18.66 2H11.4C9.37 2 7.71 3.62 7.62 5.63H5.8C3.71 5.63 2 7.34 2 9.43v10.6c0 .88.32 1.72 1.08 2.16.75.44 1.65.32 2.41-.11l3.67-2.04s.13-.05.28-.05.24.03.28.05l3.66 2.04c.77.42 1.66.55 2.41.11.76-.44 1.08-1.29 1.08-2.16v-2.75l2.11 1.18c.77.42 1.66.55 2.41.11.76-.44 1.08-1.29 1.08-2.16V5.8c0-2.09-1.71-3.8-3.8-3.8zm-3.59 18.03c0 .48-.16.6-.19.61-.03.02-.21.1-.63-.13l-3.66-2.04c-.36-.2-.78-.27-1.14-.27s-.78.07-1.14.27l-3.67 2.05c-.42.23-.6.15-.63.13s-.19-.13-.19-.61V9.43c0-1.1.9-2 2-2h7.26c1.1 0 2 .9 2 2v10.6zm5.6-3.62c0 .48-.16.6-.19.61-.03.02-.21.1-.63-.13l-2.98-1.66v-5.8c0-2.09-1.71-3.8-3.8-3.8H9.41c.09-1.02.96-1.82 1.99-1.82h7.26c1.1 0 2 .9 2 2v10.6z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BookmarkBulkIcon = makeIcon('BookmarkBulkIcon', BookmarkBulkIconSvg)
